import React from 'react'
import { Field, reduxForm } from 'redux-form'
import  validate  from './../validateReg';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose, withHandlers } from 'recompose';

import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import EmailField from '../EmailField';
import TextField from '../TextField';
import PasswordField from '../PasswordField';
import PhoneField from '../PhoneField';
import ProjectCodeField from '../ProjectCodeField';
import RenderCheckbox from '../AmLeader';


import { MDBContainer, MDBRow, MDBCol, MDBStepper, MDBStep, MDBBtn, MDBCard, MDBCardBody, MDBInput } from "mdbreact";
import DatePicker from '../DatePicker';
import Dropdown from '../Dropdown';

import { COLORS,commonStyles } from '../../../styles/styles';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import ScaleLoader from 'react-spinners/ScaleLoader';







const FirstPage = ({ classes, form, nextPage,skipPages, dropdowns, ...props }) => {
  const { handleSubmit, hadleSubmit2, checkCode, login} = props;
  const checkboxValue =
    form.registration && form.registration.values && form.registration.values.AmLeader;
    
    
  return (
    <form className="w-100" onSubmit={handleSubmit}>
      <MDBCol md="12">
        <MDBRow>
        <MDBCol md="6">
          {dropdowns.dropdowns && <Field name="conTitleID" label="Title" component={Dropdown} options={dropdowns.dropdowns.titles}  depth={10}/>}
      </MDBCol>
       
          <MDBCol md="6">
          <Field name="firstname" label="First name" component={TextField}  />
          </MDBCol>
        </MDBRow>
        <MDBRow>
       <MDBCol md="6">
       <Field name="maidenname" label="Maiden Name (Optional)" component={TextField}  />
       </MDBCol>
       <MDBCol md="6">
        
        <Field name="middlename" label="Middle Name (Optional)" component={TextField}  />
        </MDBCol>
       
        </MDBRow>
        <MDBRow>
        <MDBCol md="6">
      {dropdowns.dropdowns && <Field name="gender" label="Gender" component={Dropdown}   options={dropdowns.dropdowns.gender}  depth={5}/>}
      </MDBCol>
      <MDBCol md="6">
          <Field name="lastname" label="Last name" component={TextField}  />
          </MDBCol>
          
        </MDBRow>
        <MDBRow>
        <MDBCol md="6">
      {dropdowns.dropdowns && <Field name="identitytype" label="Alternative ID Type - South African select 'None'" component={Dropdown}   options={dropdowns.dropdowns.identityTypes}  depth={4}/>}
      </MDBCol>
        <MDBCol md="6">
          <Field name="identityNo" label="ID Number" component={TextField}  />
          </MDBCol>
        </MDBRow>
        <MDBRow>
          <MDBCol md="6">
              <div style={{float:'left'}}>
            <Field name="birthdate" label="Date of Birth" component={DatePicker}  />
            </div>
          </MDBCol>
          <MDBCol md="6">
          <Field name="cell" label="Cell Number" component={TextField}  />
          </MDBCol>
        </MDBRow>
        <MDBRow>
        <MDBCol md="12">
          <Field name="email" label="Email Address" component={EmailField}  />
          </MDBCol>
        </MDBRow>
        <MDBRow>
          <MDBCol md="12">
          <Field name="programCode" label="Program Code" component={PasswordField}  />
          </MDBCol>
        </MDBRow>
        <MDBRow>
          <MDBCol md="6">
          <Field name="password" label="Password" component={PasswordField}  />
          </MDBCol>
          <MDBCol md="6">
          <Field name="ConfirmPassword" label="Confirm Password" component={PasswordField}  />
          </MDBCol>
        </MDBRow>
        <MDBRow style={{textAlign:'right'}} className="mt-4">
        <MDBCol md="3" className="offset-md-9">
          <MDBBtn color="success"
              right
              size="md"
              className='ml-3 ml-4 mt-0 mb-2 float-right'
              action
              type="submit">
            SUBMIT
          </MDBBtn>
        </MDBCol>
        </MDBRow>
      </MDBCol>
      
      <ReactCSSTransitionGroup
          transitionName="fade"
          transitionEnterTimeout={500}
          transitionLeaveTimeout={500}>{(login.fetchingFirstPageReg==true) && <div style={{backgroundColor:'#FFFFFF', position:'absolute', top:0, left:0, height:'100%', width:'100%', zIndex:12000, textAlign:'center'}}>
          <div style={{position:'absolute', top:"40%", width:'100%'}}>
        <ScaleLoader
         
         height={35}
         width={4}
         radius={2}
         margin='2px'
         color={COLORS.cornerstoneRed}
         loading={true}
       />
       </div>
        </div>}</ReactCSSTransitionGroup>
    </form>
    // <div className={classes.regFormWrapper}>
    //   <h4 className={classes.pageNo}></h4>
    
      
    //   <div className={`${classes.halfField} ${classes.firstInRow}`}>
    //       <Field name="firstname" label="First name" component={TextField}  />
    //     </div>
    //     <div className={classes.halfField}>
    //       <Field name="lastname" label="Surname" component={TextField} />
    //     </div>
    //     <div className={`${classes.halfField} ${classes.firstInRow}`}>
    //       <Field name="cell" label="Cell" component={TextField}  />
    //     </div>
    //     <div className={classes.halfField}>
    //       <Field name="identityNo" label="ID Number" component={TextField}  />
    //     </div>
    //     <div className={classes.rowWrapper}>
    //       <div className={`${classes.halfField} ${classes.firstInRow}`}>
    //         <Field
    //           name="programCode"
    //           component={ProjectCodeField}
    //           label="Program Code"
    //           confirmButton={false}
            
    //         />
    //       </div>
    //       <div className={`${classes.halfField} ${classes.firstInRow}`}>
    //         <Field name="email" label="Email" component={EmailField}/>
    //       </div>
          
    //     </div>
    //     <div className={`${classes.halfField} ${classes.firstInRow}`}>
    //       <Field
    //         name="password"
    //         component={PasswordField}
    //         label="Password"
    //         id="adornment-password"
          
    //       />
    //     </div>
    //     <div className={classes.halfField}>
    //       <Field
    //         name="ConfirmPassword"
    //         component={PasswordField}
    //         label="Confirm Password"
    //         id="confirm-adornment-password"
           
    //       />
    //     </div>
        
    //     <div className={`${classes.halfField} ${classes.noTopLabel}`}>
    //       <Field
    //         name="AmLeader"
    //         component={RenderCheckbox}
    //         label=""
    //         checkedStatus={checkboxValue}
    //       />
    //     </div>
          
        
    //     <div>
    //       <button variant="contained"
    //         className={`${classes.defaultButton} ${classes.shortButton}`} type="submit">Next</button>
    //     </div>
     
    // </div>
  ) 
}



FirstPage.propTypes = {
  classes: PropTypes.instanceOf(Object),
  handleSubmit: PropTypes.func,
};

const styles = () => ({
  ...commonStyles,
  halfField: {
    display: 'inline-flex',
    width: '49%',
  },
  firstInRow: {
    marginRight: '2%',
  },
  label: {
    color: '#e84848',
  },
  fullField: {
    width: '100%',
  },
  regFormWrapper: {
    maxWidth: '80%',
    margin: '0 auto',
  },
  rowWrapper: {
    display: 'flex',
  },
  noTopLabel: {
    paddingTop: 10,
    paddingLeft: 14,
  },
  pageNo:{
    textAlign: 'center',
    fontFamily: 'Roboto-Bold',

  }
});
const mapStateToProps = state => ({
  form: state.form,
  checkCode: state.checkCodeReducer,
  dropdowns: state.dropdownsReducer,
  login: state.loginReducer
});

export default compose(
  reduxForm({  form: 'registration',                 // <------ same form name
  destroyOnUnmount: false,        // <------ preserve form data
  forceUnregisterOnUnmount: false,  // <------ unregister fields on unmount
  validate
}),
connect(mapStateToProps, null),
withStyles(styles),
)(FirstPage);